import { useCallback, useContext } from "react";
import { AnalyticsContext } from "@swiggy-private/checkout-core";
import {
    clickRemindMeLater,
    impressionRemindMeNudge,
    impressionResponseReceived,
    impressionThankyouCrouton,
} from "../analytics/events";

export const useCbccNudgeAnalytics = () => {
    const { clickEvent, impressionEvent } = useContext(AnalyticsContext);

    const impressionCbccNudge = useCallback(
        (discountValue: string, bannerId: string) => {
            impressionRemindMeNudge(impressionEvent, discountValue, bannerId);
        },
        [impressionEvent],
    );

    const clickCbccNudge = useCallback(
        (discountValue: string, bannerId: string) => {
            clickRemindMeLater(clickEvent, discountValue, bannerId);
        },
        [clickEvent],
    );

    const impressionCbccThankyouCrouton = useCallback(
        (bannerId: string) => {
            impressionThankyouCrouton(impressionEvent, bannerId);
        },
        [impressionEvent],
    );

    const impressionCbccResponseReceived = useCallback(
        (bannerId: string) => {
            impressionResponseReceived(impressionEvent, bannerId);
        },
        [impressionEvent],
    );

    return {
        impressionCbccNudge,
        clickCbccNudge,
        impressionCbccThankyouCrouton,
        impressionCbccResponseReceived,
    };
};
